( function( $ ) {
	if ( $( '.testimonial-slider' ).length > 0 ) {
		$( '.testimonial-slider' ).owlCarousel( {
			center: true,
			items: 1,
			loop: true,
			dots: true,
			nav: false,
			margin: 0,
			stagePadding: 400,
			responsive: {
				0: {
					stagePadding: 75,
				},
				520: {
					stagePadding: 75,
				},
				620: {
					stagePadding: 75,
				},
				720: {
					stagePadding: 100,
				},
				820: {
					stagePadding: 125,
				},
				920: {
					stagePadding: 150,
				},
				1020: {
					stagePadding: 175,
				},
				1120: {
					stagePadding: 200,
				},
				1220: {
					stagePadding: 225,
				},
				1320: {
					stagePadding: 250,
				},
				1420: {
					stagePadding: 275,
				},
				1520: {
					stagePadding: 300,
				},
				1620: {
					stagePadding: 325,
				},
				1720: {
					stagePadding: 350,
				},
				1820: {
					stagePadding: 400,
				},
				1920: {
					stagePadding: 450,
				},
				2560: {
					stagePadding: 600,
				},
			},
		} );
	}
}( jQuery ) );
